(function () {

    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }


    /************
     Thumbs Swiper
     ************/

        // if multiple class, setup multiple swipers

    const thumbsSwiper = null;

    if (section.querySelector('.productVisual').classList.contains('multiVariants')) {
        section.querySelectorAll('.productVisualThumbs').forEach(swiper => {
                new Swiper(swiper, {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                    breakpoints: {
                        0: {
                            slidesPerView: 3,
                            spaceBetween: 12,
                        },
                        300: {
                            slidesPerView: 5,
                            spaceBetween: 12,
                        },
                        801: {
                            slidesPerView: "auto",
                            spaceBetween: 12,
                        }
                    }
                });
            }
        )
    } else {
        thumbsSwiper = new Swiper(section.querySelector('.productVisualThumbs'), {
            slidesPerView: "auto",
            spaceBetween: 20,
            breakpoints: {
                0: {
                    slidesPerView: 3,
                    spaceBetween: 12,
                },
                300: {
                    slidesPerView: 5,
                    spaceBetween: 12,
                },
                801: {
                    slidesPerView: "auto",
                    spaceBetween: 12,
                }
            }
        })
    }

    /************
     Product Swiper
     ************/

        // if multiple class, setup multiple swipers

    const productSwiper = null;

    if (section.querySelector('.productVisual').classList.contains('multiVariants')) {
        section.querySelectorAll('.productVisualSwiper').forEach(swiper => {
            let parent = swiper.closest('.productVisualItem');
            new Swiper(swiper, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                autoHeight: true,
                on: {
                    slideChange: function () {
                        if (!section.querySelector(".productVisualSwiperSlide")) {
                            return;
                        }

                        // pause all videos
                        section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                            element.pause();
                        });
                    }
                },
                thumbs: {
                    swiper: parent.querySelector('.productVisualThumbs')
                }
            })
        })
    } else {
        productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoHeight: true,
            on: {
                slideChange: function () {
                    if (!section.querySelector(".productVisualSwiperSlide")) {
                        return;
                    }

                    // pause all videos
                    section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                        element.pause();
                    });
                }
            },
            thumbs: {
                swiper: thumbsSwiper,
            }
        });
        // play video on slide play click
        section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
            element.addEventListener("click", function () {
                // get video
                const video = this.closest(".productVisualSwiperSlide").querySelector("video");

                if (!video) {
                    return;
                }

                // remove play button if it hasn't already been removed
                this.querySelector(".productVisualSwiperSlidePlay")?.remove();

                // show controls
                video.controls = true;

                // play video
                video.play();
            });
        });
    }

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            // setup active functionality for multi variant class
            if (section.querySelector('.productVisual').classList.contains('multiVariants')) {
                // remove active from all classes not needed
                section.querySelectorAll(`.productVisualItem:not([data-type="${element.value}"]), .productContentWrap:not([data-type="${element.value}"])`).forEach(item => item.classList.remove("active"));

                // set active to needed classes
                section.querySelectorAll(`.productVisualItem[data-type="${element.value}"], .productContentWrap[data-type="${element.value}"]`).forEach(item => item.classList.add("active"));
            }

            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productFormSellingOptionHeaderInput[value="sub"]:checked`);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productPurchaseATC").disabled = true;
            section.querySelector(".productPurchaseATC").innerHTML = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image && productSwiper != null) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productPurchasePriceCompare");
            const reals = section.querySelectorAll(".productPurchasePriceCompareReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices
            if (activeVariant.price > allocationPrice) {
                subCompare.textContent = price(activeVariant.price);
            }
            subReal.textContent = price(allocationPrice);

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price);
            }
            oneTimeReal.textContent = price(activeVariant.price);

        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productPurchasePriceCompare");
            const realEl = section.querySelector(".productPurchasePriceReal");

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price);
            }
            realEl.textContent = price(activeVariant.price);
        }

        // if we have the shop promise block rendered, make sure to update the variant
        const paymentTerms = document.querySelector('shopify-payment-terms');
        if (paymentTerms) {
            paymentTerms.setAttribute('variant-id', activeVariant.id);
        }

        // update price
        const priceText = isSubscription() ? price(activeVariant.selling_plan_allocations[0].price) : price(activeVariant.price);

        // update title
        const titles = section.querySelectorAll(".productTitle");
        titles.forEach(title => {
            if (!title.querySelector('span')) {
                return;
            }
            title.querySelector('span').innerHTML = activeVariant.title;
        })

        /**************
         Update Description
         ***************/

        // remove active classes from the descriptions
        section.querySelectorAll('.productDescriptionVariant').forEach(item => item.classList.remove('active'));

        // add the active class to the right unique description
        section.querySelector(`.productDescriptionVariant[data-name="${activeVariant.title}"]`)?.classList.add('active');


        /**************
         Update Benefits
         ***************/

        // remove active classes from the descriptions
        section.querySelectorAll('.productBenefitsVariant').forEach(item => item.classList.remove('active'));

        // add the active class to the right unique description
        section.querySelector(`.productBenefitsVariant[data-name="${activeVariant.title}"]`)?.classList.add('active');

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productPurchaseATC").disabled = false;
            section.querySelector(".productPurchaseATC").innerHTML = "Add To Cart";
        } else {
            section.querySelector(".productPurchaseATC").disabled = true;
            section.querySelector(".productPurchaseATC").innerHTML = "Sold Out";
        }


        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productQuantityControlsBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productQuantityControlsBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productQuantityControlsValue").textContent = quantity;
        updateProduct();
    });


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productPurchaseATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productFormSellingOptionPlan').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productPurchaseATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productPurchaseATC').addEventListener("click", addToCart);
}());